import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/5 bg-[#050505] py-14 px-6"
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
          <div className="flex items-start gap-2.5 max-w-sm">
            <span className="w-8 h-8 rounded-lg bg-[#CCFF00] flex items-center justify-center flex-shrink-0">
              <Sparkles className="w-4 h-4 text-black" strokeWidth={2.5} />
            </span>
            <div>
              <p className="font-display font-extrabold text-white">
                PromptKiste <span className="text-[#CCFF00]">AI</span>
              </p>
              <p className="text-xs text-zinc-500 mt-0.5">
                Eine Norrbyte App · KI-Prompts für Suno-Musik.
              </p>
              <p className="text-xs text-zinc-600 mt-3 leading-relaxed">
                Die Abbuchung kostenpflichtiger Pläne erfolgt durch{" "}
                <a
                  href="https://www.digistore24.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-zinc-400 hover:text-[#CCFF00] underline underline-offset-2"
                >
                  Digistore24.com
                </a>
                .
              </p>
            </div>
          </div>

          <nav
            data-testid="footer-nav"
            className="flex flex-wrap items-center gap-x-8 gap-y-3 text-sm text-zinc-400"
          >
            <Link
              data-testid="footer-link-impressum"
              to="/impressum"
              className="hover:text-white transition-colors"
            >
              Impressum
            </Link>
            <Link
              data-testid="footer-link-datenschutz"
              to="/datenschutz"
              className="hover:text-white transition-colors"
            >
              Datenschutz
            </Link>
            <Link
              data-testid="footer-link-agb"
              to="/agb"
              className="hover:text-white transition-colors"
            >
              AGB
            </Link>
            <a
              data-testid="footer-link-kontakt"
              href="mailto:info@norrbyte.de"
              className="hover:text-white transition-colors"
            >
              Kontakt
            </a>
          </nav>
        </div>

        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-zinc-600">
          <span>
            © {new Date().getFullYear()} Norrbyte · Erik Schrum, Grömitz. Alle
            Rechte vorbehalten.
          </span>
          <span>Nicht offiziell mit Suno verbunden. Gemacht für Creator.</span>
        </div>
      </div>
    </footer>
  );
};
